import { createContext, useContext } from 'react';
import { type StoreApi, useStore } from 'zustand';

import type { JsonTreeStore } from './types';

export const JsonTreeStoreContext =
  createContext<StoreApi<JsonTreeStore> | null>(null);

export function useJsonTreeStore<T>(selector: (state: JsonTreeStore) => T) {
  const store = useContext(JsonTreeStoreContext);
  if (!store) {
    throw new Error('JsonTreeStoreProvider is missing.');
  }

  return useStore(store, selector);
}
